import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import { FixaModal } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModal";
import { FixaSheets } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaSheets";
import { FixaModalHeader } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalHeader";
import { FixaModalBody } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalBody";
import styles from "./MfaqInfoModal.module.css";
import { useTranslation } from "@coworker/locales";
import MfaqUpvotesGraph from "./MfaqUpvotesGraph";

type MfaqInfoModalProps = {
  visible: boolean;
  onClose: () => void;
};

function MfaqInfoModal({ visible, onClose }: MfaqInfoModalProps) {
  const { t } = useTranslation();
  return (
    <FixaModal visible={visible} handleCloseBtn={onClose}>
      <FixaSheets
        header={
          <FixaModalHeader
            title={t("aboutString", { name: "MFAQ" })}
            titleId="mfaq-info-modal"
            closeBtnClick={onClose}
          />
        }
        footer={null}
        fullSize
        labelledById="mfaq-info-modal"
      >
        <FixaModalBody>
          <div className={styles["body"]}>
            <MfaqUpvotesGraph />
            <FixaText textStyle="Heading.S" tagName="h3">
              {`MFAQ ${t("followUpTaskString")}`}
            </FixaText>
            <FixaText textStyle="Body.L">
              {t("mfaqFollowUpTaskExplanation1String")}
            </FixaText>
            <FixaText textStyle="Body.L">
              {t("mfaqFollowUpTaskExplanation2String")}
            </FixaText>
          </div>
        </FixaModalBody>
      </FixaSheets>
    </FixaModal>
  );
}

export default MfaqInfoModal;
